export default [
  'after',
  'after all',
  'although',
  'and',
  'as',
  'as a result',
  'as if',
  'as long as',
  'as much as',
  'as soon as',
  'as though',
  'because',
  'before',
  'but',
  'consequently',
  'even',
  'even if',
  'even though',
  'finally',
  'for',
  'for example',
  'furthermore',
  'hence',
  'however',
  'if',
  'if only',
  'if then',
  'if when',
  'in addition',
  'in fact',
  'in order that',
  'inasmuch',
  'incidentally',
  'indeed',
  'instead',
  'just as',
  'lest',
  'likewise',
  'meanwhile',
  'nor',
  'now',
  'now since',
  'now that',
  'now when',
  'once',
  'or',
  'provided',
  'provided that',
  'rather than',
  'since',
  'so',
  'so that',
  'supposing',
  'that',
  'though',
  'until',
  'whenever',
  'whereas',
  'wherever',
  'which',
  'who',
  'yet',
]
